import { useI18n } from '../i18n';
import { FACEBOOK_URL, INSTAGRAM_URL, LOGO, PHONE, PHONE_HREF, STORE_URL } from '../constants';

export const Footer = () => {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer>
      <div className="wrap">
        <div className="foot">
          <div className="brand-col">
            <a className="brand" href="#top">
              <img src={LOGO} alt="CR7 Museu" />
            </a>
          </div>

          <div>
            <h4>{t.footer.explore}</h4>
            <ul>
              <li>
                <a href="#foto">{t.nav.virtual}</a>
              </li>
              <li>
                <a href="#museu">{t.nav.museum}</a>
              </li>
              <li>
                <a href="#visitar">{t.nav.visit}</a>
              </li>
              <li>
                <a href={STORE_URL} target="_blank" rel="noopener">
                  {t.nav.store}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4>{t.footer.contact}</h4>
            <ul>
              <li>
                <a href={PHONE_HREF}>{PHONE}</a>
              </li>
              <li>
                <a href={FACEBOOK_URL} target="_blank" rel="noopener">
                  Facebook
                </a>
              </li>
              <li>
                <a href={INSTAGRAM_URL} target="_blank" rel="noopener">
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="foot-bottom">
          <span>© {year} CR7 Museu</span>
          <span>{t.footer.rights}</span>
        </div>
      </div>
    </footer>
  );
};
